export default "__VITE_ASSET__yZKMiBNU__"